import React, { lazy, Suspense } from "react";
import { LoadableLoader } from "./LoadableLoader";

export const loadable = (importFunc, fallback = <LoadableLoader/>) => {
    const LazyComponent = lazy(importFunc);
    return (props) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    )
};
